import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

export interface WizzardHeaderWrapperProps extends GridProps { }

export const WizzardHeaderWrapper = ({
  children,
  sx,
  ...rest
}: WizzardHeaderWrapperProps) => {
  return (
    <Grid
      sx={{
        gridTemplateColumns: { base: '1fr', md: 'auto 1fr' },
        gap: { base: 4, lg: 8 },
        ...sx
      }}
      {...rest}
    >
      {children}
    </Grid>
  )
}
